import React from 'react';

import { Box, Stack, AppBar, Toolbar, useMediaQuery } from '@mui/material';

import Logo from 'src/components/logo';

import HeaderTabs from './tabs/tabs';
import { HEADER } from '../config-layout';
import { useHeader } from './header.hook';

type HeaderProps = {
  isLogin?: boolean;
};

export default function Header({ isLogin = false }: HeaderProps) {
  const { theme } = useHeader();
  const isDown320 = useMediaQuery('(max-width: 320px)');

  return (
    <AppBar position="static">
      <Toolbar
        disableGutters
        sx={{
          gap: { xs: 1, md: 3 },
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          backgroundColor: theme.palette.common.white,
          borderBottom: '1px solid #21498366',
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          height={1}
          paddingX={{ xs: isDown320 ? '3px' : '10px', sm: '50px', md: '72px', lg: '96px' }}
          width="100%"
        >
          <Box sx={{ width: { xs: 100, sm: 150, md: 180 } }}>
            <Logo data-testid="logo" customLogo="/logo/centernorte_benefits_logo.png" />
          </Box>

          {isLogin && (
            <Box
              sx={{
                width: {
                  xs: 120,
                  sm: 160,
                  md: 200,
                },
                aspectRatio: '538 / 65',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Logo
                data-testid="logo"
                customLogo="/logo/logo_cidade_center_norte.png"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            </Box>
          )}

          {!isLogin && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1 }}>
              <HeaderTabs />
            </Box>
          )}
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
